const ModalComponent = ({
  showModal,
  title,
  handleCloseModal,
  children,
  hideHeader,
}) => {
  return (
    <>
      {showModal ? (
        <div className="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex items-start justify-end z-10 md:pt-0 h-screen">
          <div className="modal-dialog w-[95%] md:w-[80%] relative pointer-events-none">
            <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current mt-3 -ml-2 md:-ml-7">
              {!hideHeader ? (
                <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md">
                  <h5
                    className="text-lg md:text-xl font-medium leading-normal text-gray-800"
                    id="exampleModalLabel"
                  >
                    {title}
                  </h5>
                  <button
                    type="button"
                    className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
              ) : null}
              <div className="modal-body relative p-4 h-[630px] md:h-full">{children}</div>
              <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="px-6
          py-2.5
          bg-green-600
          text-white
          font-medium
          text-xs
          leading-tight
          uppercase
          rounded
          shadow-md
          hover:bg-green-700 hover:shadow-lg
          focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0
          active:bg-green-800 active:shadow-lg
          transition
          duration-150
          ease-in-out"
                  data-bs-dismiss="modal"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
export default ModalComponent;
